import { useEffect, useState } from 'react';
import { SearchInputProps } from './SearchInput.types';
import { useStyles } from './SearchInput.styles';
import InputBase from '@material-ui/core/InputBase';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import { IconButton, InputAdornment } from '@material-ui/core';
import { highContrastMode } from '../../utils/highContrastChecker';

export const SearchInput: React.FC<SearchInputProps> = ({
  onSearch,
  searchInput,
  placeholder,
  inputStyle,
  activeStyle,
  inactiveStyle,
  phraseMinLengthToStartSearching,
  searchAfterClick,
  folderChange
}) => {
  const classes = useStyles();
  const [hasFocus, setHasFocus] = useState<boolean>(false);
  const [value, setValue] = useState<string>(searchInput);

  const trimmedValue = value.trim();
  const canSearch =
    (phraseMinLengthToStartSearching === undefined && trimmedValue.length > 0) ||
    (phraseMinLengthToStartSearching !== undefined && trimmedValue.length >= phraseMinLengthToStartSearching);

  useEffect(() => {
    !searchAfterClick && canSearch && onSearch(trimmedValue);
  }, [searchAfterClick, canSearch, onSearch, trimmedValue]);

  useEffect(() => {
    if (value.length === 0) {
      onSearch(trimmedValue);
    }
  }, [trimmedValue]);

  useEffect(() => {
    setValue(searchInput);
  }, [searchInput, folderChange]);

  return (
    <div className={classes.searchBar} style={activeStyle && hasFocus ? activeStyle : inactiveStyle}>
      <InputBase
        style={inputStyle ?? undefined}
        value={value}
        placeholder={placeholder}
        inputProps={{ 'aria-label': 'Szukaj' }}
        onChange={(event) => setValue(event.target.value)}
        onFocus={() => setHasFocus(true)}
        onBlur={() => setHasFocus(false)}
        onKeyPress={(event) => {
          if (event.key === 'Enter') {
            searchAfterClick && canSearch && onSearch(value);
          }
        }}
        startAdornment={
          <InputAdornment position="start">
            <IconButton
              disableRipple
              size="small"
              disabled={!canSearch}
              onClick={() => {
                searchAfterClick && canSearch && onSearch(value);
              }}
            >
              <SearchIcon style={{ color: canSearch ? '#3C419A' : highContrastMode ? 'white' : '#2C2D3ECC' }} />
            </IconButton>
          </InputAdornment>
        }
        endAdornment={
          value.length > 0 ? (
            <InputAdornment position="end">
              <IconButton
                disableRipple
                size="small"
                onClick={() => {
                  onSearch('');
                  setValue('');
                }}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ) : undefined
        }
      />
    </div>
  );
};